<template>
  <div>
    <div id="body" class="login language-en">
      <div id="wrapper" class="wrapper-login">
        <div
          id="login-form"
          name="login-form"
          class="login-form-modal o-section--huge bg-clr--lighter-gray"
          style="background-color: #f3efe6"
        >
          <div class="o-layout o-layout--center">
            <div class="o-layout__item" style="max-width: 750px">
              <div
                id="signup"
                name="signup"
                method="post"
                class="bg-clr--white o-block o-box p-40@sm u-box-shadow"
                enctype="application/x-www-form-urlencoded"
                style="font-family: 'DM Sans', sans-serif !important"
              >
                <div class="checkout-container" v-show="mode === 'register'">
                  <div
                    class="o-block__item u-font-size--huge"
                    style="text-align: center"
                  >
                    <b>{{ $func.parseIso("joinEscapero2") }}</b> <br />
                    <div style="font-size: 60%">
                      {{ $func.parseIso("registerEscapero") }}
                    </div>
                  </div>

                  <br /><br />

                  <div class="card-form">
                    <div class="form-row">
                      <div class="form-group">
                        <label for="cardholder"
                          >{{ $func.parseIso("name") }}
                          <span style="color: red">*</span></label
                        >
                        <input
                          type="text"
                          placeholder="John"
                          v-model="newUser.name"
                          maxlength="50"
                        />
                      </div>
                      <div class="form-group">
                        <label for="cardnumber"
                          >{{ $func.parseIso("lastname") }}
                          <span style="color: red">*</span></label
                        >
                        <input
                          type="text"
                          placeholder="Smith"
                          v-model="newUser.lastname"
                          maxlength="50"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group">
                        <label for="expiration"
                          >{{ $func.parseIso("email") }}
                          <span style="color: red">*</span></label
                        >
                        <input
                          type="text"
                          placeholder="johnsmith@mail.com"
                          v-model="newUser.email"
                          maxlength="100"
                        />
                      </div>
                      <div class="form-group">
                        <label for="cvv"
                          >{{ $func.parseIso("password") }}
                          <span style="color: red">*</span></label
                        >
                        <div class="password-container">
                          <input
                            :type="isShowPass ? 'text' : 'password'"
                            v-model="newUser.password"
                            id="password"
                            maxlength="200"
                          />
                          <span class="toggle-password" @click="showPass">
                            <i
                              :class="
                                isShowPass ? 'fas fa-eye-slash' : 'fas fa-eye'
                              "
                            ></i>
                          </span>
                        </div>
                        <p style="font-size: 75%; text-align: justify">
                          {{ passOK() ? "✅" : "⚠️" }}
                          {{ $func.parseIso("changePassword__msg2") }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="divisor-personalizado">
                    <span class="linea"></span>
                    <span class="circulo">Or</span>
                    <span class="linea"></span>
                  </div>

                  <div class="wallet-buttons">
                    <button
                      class="google-signin-button"
                      @click="initializeGoogleClient"
                    >
                      <img
                        class="icon-btn-register"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/480px-Google_%22G%22_logo.svg.png"
                        alt=""
                      />

                      <span class="button-text">{{
                        $func.parseIso("registerWithGoogle")
                      }}</span>
                    </button>
                    <!-- <button class="google-signin-button">
                      <img
                        class="icon-btn-register"
                        src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                        alt=""
                      />

                      <span class="button-text">Registrarse con Apple</span>
                    </button> -->
                  </div>
                  <!-- <google-auth @auth-success="handleAuthCode"></google-auth> -->

                  <!-- <div class="divisor-personalizado">
                    <span class="linea"></span>
                    <span class="linea"></span>
                  </div> -->

                  <br /><br />

                  <div
                    class="wallet-buttons"
                    style="justify-content: end; margin: 0 !important"
                  >
                    <button class="stripe-btn" @click="mountPaymentRegister">
                      {{ $func.parseIso("next") }}
                      <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>

                  <div v-show="msgErrorLogin">
                    <br /><br />
                    <p style="text-align: center; color: red">
                      {{ msgErrorLogin }}
                    </p>
                  </div>
                </div>
                <div
                  class="checkout-container"
                  v-show="mode === 'pay-register'"
                >
                  <div
                    class="o-block__item u-font-size--huge"
                    style="text-align: center"
                  >
                    <b>{{ $func.parseIso("joinEscapero2") }}</b> <br />
                    <div style="font-size: 60%">
                      {{ $func.parseIso("registerEscapero") }}
                    </div>
                  </div>

                  <div class="billing-card">
                    <div class="billing-toggle">
                      <button
                        :class="`toggle-btn animate__animated ${
                          plan === 1 ? 'active animate__pulse' : ''
                        }`"
                        @click="plan = 1"
                      >
                        {{ $func.parseIso("monthlyBilling") }}
                      </button>
                      <button
                        :class="`toggle-btn animate__animated ${
                          plan === 2 ? 'active animate__pulse' : ''
                        }`"
                        @click="plan = 2"
                      >
                        {{ $func.parseIso("monthlyAnnual") }}
                        <span
                          :style="`margin-left: 5px; ${
                            plan === 2
                              ? 'background-color: #007bff;'
                              : 'background-color: #CBF3BB;'
                          }`"
                          >$30 off</span
                        >
                      </button>
                    </div>

                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 1
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(1)"
                      :style="`${planNone === 1 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <div class="plan-name">
                          {{ $func.parseIso("monthlyPLan") }}
                        </div>
                        <p class="plan-description" style="margin-top: -7px">
                          {{ $func.parseIso("plan__msg1") }}
                        </p>
                      </div>
                      <!-- <div class="plan-price">
                        $ 9.99 {{ $func.parseIso("plan__msg2") }}
                      </div> -->
                    </div>
                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 1
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(1)"
                      :style="`${planNone === 1 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <!-- <div class="plan-name">
                          {{ $func.parseIso("monthlyPLan") }}
                        </div> -->
                        <p class="plan-description">
                          {{ $func.parseIso("nextRenewal") }}
                        </p>
                      </div>
                      <div class="plan-price">
                        $ {{ pricePlanOne }} {{ $func.parseIso("plan__msg2") }}
                      </div>
                    </div>
                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 1
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(1)"
                      :style="`${planNone === 1 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <!-- <div class="plan-name">
                          {{ $func.parseIso("monthlyPLan") }}
                        </div> -->
                        <p class="plan-description">
                          {{ $func.parseIso("today") }}
                        </p>
                      </div>
                      <div class="plan-price">$ 0.00 USD</div>
                    </div>

                    <!-- Plan 2 -->
                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 2
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(2)"
                      :style="`${planNone === 2 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <div class="plan-name">
                          {{ $func.parseIso("annualPlan") }}
                        </div>
                        <p class="plan-description" style="margin-top: -7px">
                          {{ $func.parseIso("plan__msg1") }}
                        </p>
                      </div>
                      <!-- <div class="plan-price">
                        $ 9.99 {{ $func.parseIso("plan__msg3") }}
                      </div> -->
                    </div>
                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 2
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(2)"
                      :style="`${planNone === 2 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <!-- <div class="plan-name">
                          {{ $func.parseIso("monthlyPLan") }}
                        </div> -->
                        <p class="plan-description">
                          {{ $func.parseIso("nextRenewal") }}
                        </p>
                      </div>
                      <div class="plan-price">
                        $ {{ pricePlanTwo }} {{ $func.parseIso("plan__msg3") }}
                      </div>
                    </div>
                    <div
                      :class="`plan-details animate__animated animate__faster ${
                        plan === 2
                          ? 'animate__fadeInDown'
                          : 'animate__fadeOutDown'
                      }`"
                      @animationend="execPlanNone(2)"
                      :style="`${planNone === 2 ? 'display: none' : ''}`"
                    >
                      <div class="plan-info">
                        <!-- <div class="plan-name">
                          {{ $func.parseIso("monthlyPLan") }}
                        </div> -->
                        <p class="plan-description">
                          {{ $func.parseIso("today") }}
                        </p>
                      </div>
                      <div class="plan-price">$ 0.00 USD</div>
                    </div>
                  </div>

                  <div class="divisor-personalizado">
                    <span class="linea"></span>
                    <span class="linea"></span>
                  </div>

                  <!-- <div class="wallet-buttons" id="payment-element-express">
                    <button class="google-signin-button">
                      <img
                        class="icon-btn-register"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/480px-Google_%22G%22_logo.svg.png"
                        alt=""
                      />

                      <span class="button-text">Pagar con Google Pay</span>
                    </button> 
                  </div> -->

                  <!-- <div class="divisor-personalizado">
                    <span class="linea"></span>
                    <span class="circulo">{{
                      $func.parseIso("registerPublicEscapero__title7")
                    }}</span>
                    <span class="linea"></span>
                  </div> -->

                  <form class="card-form">
                    <div class="form-row">
                      <div class="form-group">
                        <label for="cardholder">{{
                          $func.parseIso("cardholderName")
                        }}</label>
                        <input
                          type="text"
                          placeholder="John Doe"
                          v-model="newUser.cardholderName"
                          pattern="[a-z]"
                        />
                      </div>
                      <div class="form-group">
                        <label for="cardnumber">{{
                          $func.parseIso("cardNumber")
                        }}</label>
                        <div class="div-elements" id="cardnumber"></div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group">
                        <label for="expiration">{{
                          $func.parseIso("cardExpiration")
                        }}</label>
                        <div class="div-elements" id="cardexpiration"></div>
                        <!-- <input type="text" placeholder="MM/YY" /> -->
                      </div>
                      <div class="form-group">
                        <label for="cvv">{{ $func.parseIso("cardCvc") }}</label>
                        <div class="div-elements" id="cardcvv"></div>
                        <!-- <input type="text" placeholder="123" /> -->
                      </div>
                      <div class="form-group">
                        <label for="postal">{{ $func.parseIso("zip") }}</label>
                        <input
                          type="text"
                          id="postal"
                          v-model="newUser.zip"
                          placeholder="Postal or ZIP code"
                          v-mask="'######'"
                        />
                      </div>
                    </div>
                  </form>

                  <br />
                  <div class="wallet-buttons" style="margin: 0 30% !important">
                    <button
                      class="stripe-btn"
                      @click="pay"
                      v-if="!payOk && !loadingRegister"
                    >
                      {{ $func.parseIso("startTrial") }}
                      <i class="fas fa-lock"></i>
                    </button>
                    <button class="stripe-btn" v-if="!payOk && loadingRegister">
                      <div
                        class="animate__animated animate__heartBeat animate__infinite"
                      >
                        {{ $func.parseIso("startTrial") }}
                        <i class="fas fa-lock"></i>
                      </div>
                    </button>
                  </div>
                  <p
                    class="animate__animated animate__flash"
                    v-if="payOk && !errorLogin"
                    style="color: #0056b3; text-align: center; font-weight: 600"
                  >
                    {{ $func.parseIso("registerPublicEscapero__title8") }}
                    <!-- <i class="fas fa-check"></i> -->
                  </p>
                  <p
                    class="animate__animated animate__flash"
                    v-if="payOk && errorLogin"
                    style="color: #0056b3; text-align: center; font-weight: 600"
                  >
                    {{ $func.parseIso("registerPublicEscapero__title8") }}
                    <!-- <i class="fas fa-check"></i> -->
                  </p>

                  <div>
                    <br />
                    <p
                      style="text-align: center; color: red"
                      v-show="msgErrorLogin"
                    >
                      {{ msgErrorLogin }}
                    </p>
                  </div>

                  <br /><br /><br />
                  <div style="display: flex; justify-content: center">
                    <img
                      draggable="false"
                      src="https://ticemadox.com/wp-content/uploads/2019/03/power-by-stripe_03.png"
                      alt=""
                      style="width: 30%; opacity: 0.5; margin-bottom: -40px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <Footer :isDefault="isDefault" :club="club" /> -->
    <Alert
      :show="alertLogin.show"
      :title="alertLogin.title"
      :closeAlert="alertLogin.close || closealertLogin"
    />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import HeaderLogin from "../components/HeaderLogin.vue";
import Alert from "../components/Alert.vue";
import ModalStripe from "./StripeElementsEscapero.vue";
import axios from "axios";
const { VUE_APP_TC_URL } = process.env;
import { getClubObject, setTokenTCAndExpireToken } from "../utils/sesions";
import { newUser, password, zip } from "@/utils/i18n_data";
import { load } from "@fingerprintjs/fingerprintjs";
const CLUBS_V2 = [
  "96213bc2-b460-414e-980a-d0bd99d0869c",
  "f908ec94-2a57-4478-a330-9104af639e42",
  "22c92470-937f-48dc-87d3-9baa06447628",
  "b1ccd89f-f90f-470f-9ffb-acbe5f082df8",
];
const IMAGES_LOGIN = [
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-0.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-2.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-5.jpg",
  "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-1.jpg",
];

const PasswordValidator = require("password-validator");
const passhigh = new PasswordValidator();
const passmedium = new PasswordValidator();
const passlow = new PasswordValidator();
passhigh
  .is()
  .min(8)
  .is()
  .max(255)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits(1)
  .has()
  .not()
  .spaces()
  .has()
  .symbols(1);

passmedium
  .is()
  .min(4)
  .is()
  .max(255)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits(1)
  .has()
  .not()
  .spaces();

passlow.is().min(1).is().max(255).has().lowercase().has().not().spaces();

const stripe = Stripe(process.env.VUE_APP_KEY_STRIPE, {
  locale: "en",
});

import emailValidator from "email-validator";

export default {
  data() {
    return {
      email: null,
      password: null,
      iso: "en",
      show: false,
      club: null,
      isDefault: true,
      isShowPass: false,
      UrlTC: null,
      MicrositeTC: null,
      ClubId: null,
      CLUBS_V2,
      IMAGES_LOGIN,
      img: "https://booking.vacancyrewards.com/javax.faces.resource/index-background/background-0.jpg",
      btnColor: null,
      loadingLogin: false,
      loadingRegister: false,
      errorLogin: null,
      msgErrorLogin: "",
      alertLogin: {
        show: false,
        title: `We’ve improved your login experience!
        Use your registered email to access your account (each owner and co-owner now has their own access using their registered email).`,
        description: "",
        close: null,
      },
      newUser: {
        name: null,
        lastname: null,
        email: null,
        password: null,
        // phone: 1,
        ladaphone: null,
        cardholderName: null,
        zip: null,
      },
      showValidPass: false,
      stepValidPass: 0,
      acceptTerms: false,
      Cat: {
        CatPaises: [],
        CatEstadosPais: [],
        CatIdiomas: [],
      },
      ColorSecundarioHex: "",
      clientSecretPayRegister: null,
      clientSecretPayRegisterAnual: null,
      plan: 1,
      planNone: 2,
      cardNumberElements: null,
      cardExpirationElements: null,
      cardCvvElements: null,
      expressElements: null,
      mode: "register",
      pricePlanOne: "9.99",
      pricePlanTwo: "89.99",
      payOk: false,
      clientGoogle: null,
      isGoogleRegister: false,
    };
  },
  components: {
    Footer,
    HeaderLogin,
    Alert,
    ModalStripe,
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });
    // await this.checkClub();
    this.img = this.getImgs();

    const __club = getClubObject();
    if (__club?.ColorPrimarioHex) this.btnColor = __club?.ColorPrimarioHex;
    if (__club?.ColorSecundarioHex)
      this.ColorSecundarioHex = __club?.ColorSecundarioHex;

    //Check Alert
    const {
      query: { alert },
    } = this.$route;
    if (alert && alert === "confirmPayment") {
      this.alertLogin.title = this.$func.parseIso("registerUser__msg2");
      this.alertLogin.show = true;
    }

    // await this.payElements();
    // await this.payElements2();
    await this.getCatalogues();
  },
  async updated() {
    // this.show = true;
    // this.$forceUpdate();
    await this.checkClub();
  },
  mounted() {
    const appearance = {
      // theme: "stripe",
    };
    const options = {
      // hidePostalCode: true,
      // iconStyle: "solid",
      // disableLink: true,
      showIcon: true,
      // style: {
      //   base: {

      //     padding: '0.875rem',
      //     fontSize: '1rem',

      //     iconColor: "#c4f0ff",
      //     color: "#fff",
      //     fontWeight: "500",
      //     fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      //     fontSize: "16px",
      //     fontSmoothing: "antialiased",
      //     ":-webkit-autofill": {
      //       color: "#fce883",
      //     },
      //     "::placeholder": {
      //       color: "#87BBFD",
      //     },
      //   },
      //   invalid: {
      //     iconColor: "#FFC7EE",
      //     color: "#FFC7EE",
      //   },
      // },
    };
    const elements = stripe.elements({
      // clientSecret: this.clientSecret,
      // appearance,
    });

    //cardnumber
    const cardNumberPaymentElement = elements.create("cardNumber", options);
    cardNumberPaymentElement.mount("#cardnumber");
    this.cardNumberElements = cardNumberPaymentElement;

    //expiration
    const expirationPaymentElement = elements.create("cardExpiry", options);
    expirationPaymentElement.mount("#cardexpiration");
    this.cardExpirationElements = expirationPaymentElement;

    //cvv
    const cvvPaymentElement = elements.create("cardCvc", options);
    cvvPaymentElement.mount("#cardcvv");
    this.cardCvvElements = cvvPaymentElement;

    //express
    // const optionsExpress = {
    //   paymentMethods: {
    //     amazonPay: "never",
    //     googlePay: "always",
    //     link: "never",
    //     applePay: "never",
    //   },
    //   buttonType: {
    //     // applePay: "subscribe",
    //     googlePay: "subscribe",
    //   },
    //   layout: {
    //     maxRows: 2,
    //   },
    //   buttonHeight: 40,
    //   buttonTheme: {
    //     applePay: "white-outline",
    //     googlePay: "white",
    //   },
    // };
    // const elementsExpress = stripe.elements({
    //   // clientSecret: this.clientSecret,
    //   // appearance,
    // });
    // const paymentElementExpress = elementsExpress.create(
    //   "expressCheckout",
    //   optionsExpress
    // );
    // paymentElementExpress.mount("#payment-element-express");
    // this.expressElements = paymentElementExpress;
  },
  methods: {
    closealertLogin() {
      this.alertLogin.show = false;
    },
    getImgs() {
      const random = (mn, mx) => {
        return Math.random() * (mx - mn) + mn;
      };
      return IMAGES_LOGIN[Math.floor(random(1, 4)) - 1];
    },
    changeIso() {
      if (this.iso === "es") {
        localStorage.setItem("iso", "en");
        this.iso = "en";
      } else {
        localStorage.setItem("iso", "es");
        this.iso = "es";
      }
    },
    async login(email, password) {
      try {
        // this.loadingLogin = true;
        // this.errorLogin = null;

        const { data } = await this.$axios.post("/members-public/login", {
          email,
          password,
          clubId: this.ClubId || "all",
        });

        setTokenTCAndExpireToken(data?.token, data?.exp, data?.sesion);
        const __MicrositeTC__ = data?.MicrositeTC || this.MicrositeTC;
        const __UrlTC__ = data?.UrlTC || this.UrlTC;
        // const checkTerms =
        //   data?.AcceptTermsWeeks && data?.AcceptTermsWeeks === true
        //     ? true
        //     : false;

        const URL_REDIRECT_DASHBOARD = `https://${__UrlTC__}?submit=true&keepurl=true&token=${data?.token}&microsite=${__MicrositeTC__}`;
        window.location.href = URL_REDIRECT_DASHBOARD;
        // this.loadingLogin = false;
      } catch (error) {
        // this.loadingLogin = false;
        // const codeError = error?.response?.data?.code || 405;
        // const msgErrorLogin = error?.response?.data?.message || "";
        // this.errorLogin = codeError;
        // this.msgErrorLogin = msgErrorLogin;
        console.log(error);
        this.$router.push("/");
        // this.errorLogin = true
        // this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg8");
        // alert(error?.response?.data?.message);
      }
    },
    checkClub() {
      return new Promise((resolve, reject) => {
        // try {
        //   const { data } = await this.$axios.get(`/auth/club`);
        //   this.club = data.club;
        //   this.isDefault = data.default;
        // } catch (error) {
        //   console.log(error);
        //   // alert(error?.response?.data?.message);
        // }
        console.log("2. checkClub");
        const { UrlTC, MicrositeTC, Id } = getClubObject();
        // console.log("UrlTC", UrlTC);
        // console.log("MicrositeTC", MicrositeTC);
        // console.log("Id", Id);
        // console.log("getClubObject()", getClubObject());
        this.UrlTC = UrlTC;
        this.MicrositeTC = MicrositeTC;
        this.ClubId = Id;
        return resolve();
      });
    },
    showPass() {
      this.isShowPass = !this.isShowPass;
    },
    goToRecoverPassword() {
      this.$router.push("/recover-password");
    },
    goToGoogleAuthRegister() {
      // const uriRedirect =
      //   process.env.VUE_APP_API_URL +
      //   process.env.VUE_APP_URL_GOOGLE_REDIRECT_REGISTER;
      const uriRedirect = `https://vr.vacancyrewards.com/api/members-public/register/google/callback`;
      // const uriRedirect = `http://localhost:3010/api/members-public/register/google/callback`;
      window.open(
        `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${uriRedirect}&display=popup&response_type=code&client_id=758621452580-p1em4evmcujd5ufl5b64b7s8ohahnd9h.apps.googleusercontent.com&scope=profile email`,
        "google-login",
        "width=500,height=600,scrollbars=yes"
      );
    },
    goToGoogleAuthLogin() {
      // const uriRedirect =
      //   process.env.VUE_APP_API_URL +
      //   process.env.VUE_APP_URL_GOOGLE_REDIRECT_LOGIN;
      const uriRedirect = `https://vr.vacancyrewards.com/api/members-public/login/google/callback`;
      // const uriRedirect = `http://localhost:3010/api/members-public/login/google/callback`;
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${uriRedirect}&response_type=code&client_id=758621452580-p1em4evmcujd5ufl5b64b7s8ohahnd9h.apps.googleusercontent.com&scope=profile email`;
    },
    async registerCaptcha() {
      return new Promise((resolve, reject) => {
        try {
          grecaptcha.ready(function () {
            grecaptcha
              .execute("6LfE54IrAAAAAIhI6THMMT6FRpzyrn-nLSqBDp8z", {
                action: "submit",
              })
              .then(function (token) {
                return resolve(token);
              })
              .catch(function (error) {
                return reject();
                console.log("error", error);
              });
          });
        } catch (error) {
          console.log(error);
          return reject();
        }
      });
    },
    async registerExec(token) {
      try {
        this.loadingRegister = true;
        this.errorLogin = null;

        const { data } = await this.$axios.post("members-public/register", {
          ...this.newUser,
          token,
          autologin: true,
          clubId: this.ClubId || null,
          typeSub: 2,
          captcha: true,
        });

        if (data?.redirect) window.location.href = data?.urlPay;
        else this.login(this.newUser.email, this.newUser.password);

        this.loadingRegister = false;

        // this.newUser.name = "";
        // this.newUser.lastname = "";
        // this.newUser.email = "";
        // this.newUser.password = "";

        // this.alertLogin.title = this.$func.parseIso("registerUser__msg1");
        // this.alertLogin.close = this.closeAlertRegister;
        // this.alertLogin.show = true;
      } catch (error) {
        this.loadingRegister = false;
        const codeError = error?.response?.data?.code || 405;
        const msgErrorLogin = error?.response?.data?.message || "";
        this.errorLogin = codeError;
        this.msgErrorLogin = msgErrorLogin;

        this.alertLogin.title = msgErrorLogin;
        this.alertLogin.close = this.closeAlertRegister;
        this.alertLogin.show = true;
        console.log(error);
        // alert(error?.response?.data?.message);
      }
    },
    closeAlertRegister() {
      this.alertLogin.show = false;
      // this.mode = "login";
    },
    validaPass() {
      if (this.newUser.password === "" || !this.newUser.password) return 0;

      if (passhigh.validate(this.newUser.password)) {
        return 3;
      } else if (passmedium.validate(this.newUser.password)) {
        return 2;
      } else if (passlow.validate(this.newUser.password)) {
        return 1;
      } else {
        return -1;
      }
    },
    async validRegister() {
      try {
        const token = await this.registerCaptcha();
        // console.log('token', token)
        await this.registerExec(token);
      } catch (error) {
        console.log(error);
      }
    },
    async getCatalogues() {
      try {
        const list = ["CatPaises", "CatEstadosPais", "CatIdiomas"];

        for (let l of list) {
          const { data } = await this.$axios.get(`/catalogue/${l}`);
          this.Cat[l] = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async payElements() {
      try {
        const { data: payment } = await this.$axios.get(
          `/payment/create/payment-intent-escapero`
        );
        console.log("payment", payment);
        this.clientSecretPayRegister = payment.clientSecret;
        await this.$forceUpdate();
      } catch (error) {
        alert("Error al reservar o pagar");
        console.log(error);
      }
    },
    async payElements2() {
      try {
        const { data: payment } = await this.$axios.get(
          `/payment/create/payment-intent-escapero?plan=anual`
        );
        console.log("payment", payment);
        this.clientSecretPayRegisterAnual = payment.clientSecret;
        await this.$forceUpdate();
      } catch (error) {
        alert("Error al reservar o pagar");
        console.log(error);
      }
    },
    execPlanNone(plan) {
      if (this.plan !== plan) {
        this.planNone = plan;
      }
    },
    mountPaymentRegister() {
      this.msgErrorLogin = null;

      if (
        !this.newUser.password ||
        !this.newUser.name ||
        !this.newUser.lastname ||
        !this.newUser.email
      ) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg1");
        return;
      } else if (!emailValidator.validate(this.newUser.email)) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg3");
        return;
      } else if (!passhigh.validate(this.newUser.password)) {
        this.msgErrorLogin = this.$func.parseIso("changePassword__msg3");
      } else {
        this.msgErrorLogin = null;
        this.mode = "pay-register";
      }
    },
    async pay() {
      this.msgErrorLogin = null;

      if (!this.newUser.cardholderName) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg6");
      } else if (!this.newUser.zip) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg5");
        return;
      } else if (!/^[a-zA-Z\s]+$/.test(this.newUser.cardholderName)) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg4");
      } else {
        try {
          this.loadingRegister = true;

          //Creamos el metodo de pago
          const { paymentMethod } = await stripe.createPaymentMethod({
            type: "card",
            card: this.cardNumberElements,
            billing_details: {
              name: this.newUser.cardholderName,
            },
          });

          await this.$axios.post(`/payment/create/create-sub-escapero`, {
            paymentMethodId: paymentMethod.id,
            plan: this.plan,
            client: {
              ...this.newUser,
              isGoogleRegister: this.isGoogleRegister,
            },
            iso: this.iso,
          });

          this.loadingRegister = false;
          this.payOk = true;

          await this.login(this.newUser.email, this.newUser.password);
        } catch (error) {
          console.log(error);
          this.loadingRegister = false;
          this.msgErrorLogin =
            "An unexpected error occurred. Please try again.";
        }
      }
    },
    initializeGoogleClient() {
      this.msgErrorLogin = null;

      this.clientGoogle = google.accounts.oauth2.initCodeClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope:
          "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
        ux_mode: "popup",
        callback: this.handleAuthCodeResponse,
        redirect_uri: window.location.origin,
      });

      this.clientGoogle.requestCode();
    },
    async handleAuthCodeResponse(response) {
      try {
        if (response.error) {
          this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg7");
        } else {
          const { data } = await this.$axios.get(
            `/members-public/register/google-escapero/callback?code=${response.code}&scope=${response.scope}`
          );

          const { name, lastname, email, password } = data;
          this.newUser.name = name;
          this.newUser.lastname = lastname;
          this.newUser.email = email;
          this.newUser.password = password;

          this.isGoogleRegister = true;
          this.msgErrorLogin = null;
          this.mode = "pay-register";
        }
      } catch (error) {
        this.msgErrorLogin = this.$func.parseIso("mandatoryField__msg7");
      }
    },
    passOK() {
      return passhigh.validate(this.newUser.password);
    },
  },
};
</script>

<style scoped>
.button--loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-loading-spinner 1s ease infinite;
}
@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>

<style scoped>
/* --- Variables Globales y Reseteo --- */
:root {
  --dribbble-pink: #5e6c5b;
  --text-dark: #0d0c22;
  --text-light: #6e6d7a;
  --border-light: #e7e7e9;
  --background-light: #f8f8f8;
}

/* MEJORA: 
  Reseteo de box-sizing. Una mejor práctica.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* --- Contenedor Principal --- */
.checkout-container {
  /* background-color: #ffffff; */
  /* border-radius: 8px; */
  padding: 2rem;
  /* max-width: 500px; */
  /* width: 100%; */
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); */
}

/* --- Selector de Planes --- */
.plan-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

/* MEJORA: 
  Ocultamos el radio button real de forma accesible.
*/
.plan-radio-input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}

/* MEJORA: 
  El 'label' es ahora la tarjeta completa.
*/
.plan-option {
  border: 2px solid var(--border-light);
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  position: relative;
}

.plan-option:hover {
  border-color: #aaa;
}

/* .plan-details {
  margin-right: 0.5rem; 
}

.plan-details strong {
  font-size: 1rem;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
}

.plan-details span {
  font-size: 0.875rem; 
  color: var(--text-light);
} */

.discount-badge {
  background-color: #fdeff4; /* Fondo rosa claro */
  color: var(--dribbble-pink);
  font-size: 0.75rem; /* 12px */
  font-weight: 700;
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  margin-left: 0.5rem;
}

/* MEJORA: 
  Estilos para el radio button falso (el círculo).
*/
.custom-radio {
  flex-shrink: 0; /* Evita que se encoja */
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-light);
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Círculo rosa interior (oculto por defecto) */
.custom-radio::after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: var(--dribbble-pink);
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.2s ease;
}

/* MEJORA CLAVE: 
  Estilos que se aplican al label (y sus hijos) 
  cuando el input real está :checked
*/
.plan-radio-input:checked + .plan-option {
  border-color: var(--dribbble-pink);
  background-color: rgba(94, 108, 91, 0.7);
}

.plan-radio-input:checked + .plan-option .custom-radio {
  border-color: var(--dribbble-pink);
}

.plan-radio-input:checked + .plan-option .custom-radio::after {
  opacity: 1;
  transform: scale(1);
}

/* Estado de Foco para accesibilidad (navegando con Tab) */
.plan-radio-input:focus + .plan-option {
  border-color: var(--dribbble-pink);
  /* box-shadow: 0 0 0 3px #fdeff4; */
}

.plan-approx {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  font-size: 0.75rem;
  color: var(--text-light);
  padding: 0 0.25rem; /* Ajustado */
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}

/* --- Botones de Pago --- */
.wallet-buttons {
  display: grid;
  /* grid-template-columns: 1fr 1fr;
  gap: 1rem; */
  margin: 0 12%;
}

.wallet-btn {
  padding: 0.875rem;
  border-radius: 8px;
  border: 1px solid var(--border-light);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease; /* MEJORA: Transición */
}

.wallet-btn.paypal {
  background-color: #fff;
  /* Idealmente, aquí iría un SVG del logo */
}

.wallet-btn.paypal:hover {
  background-color: #f7f7f7; /* MEJORA: Hover */
}

.wallet-btn.gpay {
  background-color: #000;
  color: #fff;
  border-color: #000;
  /* Idealmente, aquí iría un SVG del logo */
}

.wallet-btn.gpay:hover {
  background-color: #333; /* MEJORA: Hover */
}
/* 
.divider {
  text-align: center;
  font-size: 0.875rem;
  color: var(--text-light);
  margin: 1.5rem 0;
} */

/* --- Formulario de Tarjeta --- */
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-group input {
  width: 100%;
  padding: 0.875rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group .div-elements {
  width: 100%;
  padding: 0.875rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group input::placeholder {
  color: #aaa;
}

.form-group input:focus {
  outline: none;
  border-color: var(--dribbble-pink);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.password-container {
  position: relative;
  width: 100%;
}
.password-container input {
  padding-right: 3rem;
}
.toggle-password {
  position: absolute;
  top: 50%;
  right: 0.875rem;
  transform: translateY(-50%);
  cursor: pointer;
  color: #777;
  font-size: 1.2rem; /* El tamaño se aplica al icono <i> */
  transition: color 0.2s ease;
  z-index: 10;
}

.form-row {
  display: flex;
  gap: 1rem;
}

.form-row .form-group {
  flex: 1;
}

/* --- Resumen de Facturación --- */
/* hr {
  border: 0;
  border-top: 1px solid var(--border-light);
  margin: 2rem 0;
} */

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
}

.summary-row .label {
  color: var(--text-light);
  font-weight: 500;
}

.summary-row .value {
  font-weight: 600;
  text-align: right;
}

.summary-row .value span {
  display: block;
  font-size: 0.75rem;
  color: var(--text-light);
  font-weight: 400;
}

.summary-row.discount {
  color: var(--dribbble-pink);
}

.summary-row.discount .value span {
  color: var(--dribbble-pink);
  opacity: 0.8;
}

.summary-row.total {
  font-size: 1.125rem; /* 18px */
  font-weight: 700;
  margin-top: 1rem;
  color: var(--text-dark);
}

.summary-row.total .value {
  font-size: 1.25rem; /* 20px */
}

.summary-row.total .value span {
  font-size: 0.875rem;
  color: var(--text-light);
}

/* * Estilos para el botón de Google 
 */

.google-signin-button {
  /* Modelo de caja (Box Model) */
  display: inline-flex; /* Permite alinear el ícono y el texto */
  align-items: center; /* Centra verticalmente */
  justify-content: center; /* Centra horizontalmente */
  padding: 5px 20px; /* Espaciado interno (vertical, horizontal) */
  border-radius: 4px; /* Esquinas redondeadas */
  border: 1px solid #dadce0; /* Borde gris claro estándar de Google */

  font-size: 14px;
  font-weight: 500; /* Un poco más grueso que lo normal */
  color: #3c4043; /* Color de texto gris oscuro */

  /* Visual */
  background-color: #ffffff; /* Fondo blanco */
  cursor: pointer; /* Muestra una manito al pasar el ratón */
  transition: background-color 0.3s, border-color 0.3s; /* Transición suave */

  /* Quita estilos por defecto del botón */
  outline: none;

  width: 100%;
}

/* Efecto al pasar el ratón (hover) */
.google-signin-button:hover {
  background-color: #f8f9fa; /* Fondo ligeramente gris */
  border-color: #c6c6c6; /* Borde un poco más oscuro */
}

/* Efecto al hacer clic (active) */
.google-signin-button:active {
  background-color: #f1f3f4;
  border-color: #b0b0b0;
}

/* Estilos para el ícono SVG */
.google-icon {
  width: 18px;
  height: 18px;
  margin-right: 12px; /* Espacio entre el ícono y el texto */
}

.apple-icon {
  width: 16px; /* Ajustado al SVG */
  height: 16px;
  margin-right: 8px; /* Espacio entre logo y texto */
  color: #ffffff; /* El SVG usa 'currentColor' */
}

/* Estilos para el texto (opcional, pero buena práctica) */
.button-text {
  line-height: 1; /* Asegura que el texto se alinee bien */
}

.icon-btn-register {
  width: 16px;
  height: 16px;
  margin: 2%;
}

.divisor-personalizado {
  display: flex; /* Activa Flexbox */
  align-items: center; /* Centra verticalmente los elementos */
  text-align: center;
  width: 100%; /* Ocupa todo el ancho disponible */
  margin: 5% 0; /* Añade un poco de espacio arriba y abajo */
}

/* Estilo para las líneas */
.divisor-personalizado .linea {
  flex-grow: 1; /* ¡Esta es la clave! Hace que las líneas crezcan y ocupen todo el espacio sobrante */
  height: 1px; /* Grosor de la línea */
  background-color: #d8d8e0; /* Color gris/lila claro, similar al de la imagen */
}

/* Estilo para el círculo del medio */
.divisor-personalizado .circulo {
  /* Tamaño y forma */
  /* width: 24px; */
  height: 24px;
  border-radius: 50%; /* Esto lo hace perfectamente redondo */
  border: 0; /* Color del borde del círculo */

  /* Espaciado */
  margin: 0 12px; /* Separa el círculo de las líneas */

  /* Para centrar la 'O' perfectamente dentro del círculo */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estilo de la 'O' */
  color: #a0a0b0; /* Color de la letra 'O' */
  font-size: 14px;
  font-weight: bold;
  line-height: 1; /* Asegura que no haya altura de línea extra */
}

/* --- Selector de Facturación --- */

.billing-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-light);
  border-radius: 8px; /* Contenedor exterior redondeado */
  padding: 1%;
  padding-top: 4%;
  margin-bottom: 24px;
  /* IMPORTANTE: el fondo del toggle es transparente, no blanco, para que el fondo de la tarjeta se vea */
  background-color: transparent;
}

.toggle-btn {
  padding: 8px 16px;
  border: 1px solid #5e6c5b; /* Borde transparente por defecto */
  background: transparent;
  /* background-color: rgba(94, 108, 91, 0.7); */
  color: var(--secondary-text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px; /* Botones interiores redondeados */
  transition: all 0.2s ease;
  /* IMPORTANTE: Quitar los márgenes negativos, el padding del padre lo maneja */
  margin: 1%;
  /* Asegura que el texto no se seleccione al hacer clic rápido */
  user-select: none;
  -webkit-user-select: none; /* Para navegadores Webkit */
  -moz-user-select: none; /* Para Firefox */
}

.toggle-btn.active {
  /* El botón activo tiene su propio fondo, borde y sombra */
  background: #ffffff; /* Fondo blanco para el botón activo */
  color: white;
  border: 1px solid #5e6c5b; /* Borde un poco más oscuro */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08); /* Sombra más definida */
  /* No necesitamos -1px de margen aquí porque el padding del padre ya lo gestiona */
  background-color: rgba(94, 108, 91, 0.7);
}

/* --- Detalles del Plan (sin cambios, ya estaban bien) --- */

.plan-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1%;
}

.plan-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-text);
  margin-bottom: 4px;
}

.plan-description {
  font-size: 14px;
  color: var(--secondary-text);
  margin: 0;
}

.plan-price {
  /* font-size: 16px; */
  font-weight: 600;
  color: var(--primary-text);
  white-space: nowrap;
  margin-left: 16px;
}

/* --- Divisor --- */

.divider {
  border: none;
  height: 1px;
  background-color: var(--border-light);
  margin: 0;
}

/* Boton de stripe */
.stripe-btn {
  /* Reseteo y visualización */
  display: inline-block; /* Permite ancho/alto y respeta el flujo de texto */
  padding: 10px 30px;
  border: none; /* Elimina el borde 3D por defecto */
  border-radius: 5px; /* Esquinas ligeramente redondeadas */
  cursor: pointer; /* Indica que es clickeable */
  text-align: center;
  text-decoration: none; /* Para usarlo en enlaces <a> como botón */

  /* Tipografía */
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  font-family: inherit;

  /* Colores */
  background-color: #007bff; /* Un azul primario */
  color: white; /* Texto blanco */

  /* Transiciones para suavizar los efectos hover/active */
  transition: background-color 0.3s ease, transform 0.1s ease;
}

/* Estado Hover: Cuando el cursor está sobre el botón */
.stripe-btn:hover {
  background-color: #0056b3; /* Un azul un poco más oscuro */
}

/* Estado Active: Cuando el botón está siendo presionado */
.stripe-btn:active {
  background-color: #004085; /* Azul aún más oscuro */
  transform: translateY(
    1px
  ); /* Un ligero desplazamiento hacia abajo para el efecto "presionado" */
}

/* Estado Focus: Para accesibilidad, cuando se navega con el teclado */
.stripe-btn:focus {
  outline: none; /* Elimina el foco por defecto del navegador */
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5); /* Agrega un anillo de foco */
}

/* Estado Disabled (Opcional): Para botones inactivos */
.stripe-btn:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
</style>
